import { Component } from 'react'
import {
  Box,
} from '@mui/material';

import logo from '../assets/images/logo32.png';

type Props = {};

type State = {
  content: string;
}

export default class Footer extends Component<Props, State> {
  render() {
    return (
      <div className='container-fluid'>
        <footer>
          <Box className='container-fluid mt-5 mb-5'>
            <div>
              <img src={logo} alt='logo' height='16' />&nbsp;&nbsp;Invant Inc.
            </div>
          </Box>
        </footer>
      </div>
    );
  }
}
